import { config } from "../config";

/** Rewarded ads only when an Ad Manager unit is configured (or simulated on a dev server); otherwise the page neither
 * offers them nor tells anyone to watch one. Read at call time, so a test can switch it. */
export function adsEnabled(): boolean {
  return Boolean(config.adUnitPath) || config.fakeAds;
}
